import { getApiUrl } from "../../services/apiConfig.js";
/* Institutional ranking counters and audited adjustments. Student answers and tokens stay separate. */
(function () {
  "use strict";

  const node = (tag, cls, text) => {
    const createElementResult = document.createElement(tag);
    if (cls) createElementResult.className = cls;
    if (text !== undefined) createElementResult.textContent = text;
    return createElementResult;
  };
  const number = (value) =>
    new Intl.NumberFormat("pt-BR", {
      maximumFractionDigits: 3,
    }).format(Number(value));
  function mount(root, session, institutionId, options = {}) {
    const house = Number(institutionId),
      role = session?.tipo;
    if (!house || !["admin", "instituicao"].includes(role)) {
      root.textContent = "Consulta da instituição obrigatória.";
      return () => root.replaceChildren();
    }
    if (!document.querySelector("link[data-institutions]")) {
      const link = node("link");
      link.rel = "stylesheet";
      link.href = "/static/css/institutions-v1.css?v=scope-7918dab5dfba";
      link.dataset.institutions = "1";
      document.head.append(link);
    }
    let alive = true,
      generation = 0,
      page = 1,
      search = "";
    const controllers = new Set();
    root.classList.add("di-root", "dp-management");
    const button = (text, index) => {
      const nodeResult = node("button", "di-button", text);
      nodeResult.type = "button";
      nodeResult.onclick = index;
      return nodeResult;
    };
    function headers() {
      let current;
      try {
        current = JSON.parse(sessionStorage.getItem("auth_session") || "null");
      } catch {}
      if (
        !current ||
        current.tipo !== role ||
        String(current.data?.id) !== String(session.data?.id) ||
        current.data?.access_token !== session.data?.access_token ||
        current.data?.token !== session.data?.token
      )
        throw Error("A conta mudou. Entre novamente para continuar.");
      const data = {};
      if (role === "admin") {
        if (session.data?.token) data["X-Admin-Token"] = session.data.token;
        if (session.data?.learning_admin_token)
          data["X-Learning-Token"] = session.data.learning_admin_token;
      } else data.Authorization = "Bearer " + session.data.access_token;
      return data;
    }
    async function request(path, init = {}) {
      const controller = new AbortController();
      controllers.add(controller);
      try {
        const response = await fetch(getApiUrl(path), {
          ...init,
          headers: {
            ...headers(),
            ...init.headers,
          },
          signal: controller.signal,
          credentials: "same-origin",
          cache: "no-store",
        });
        const json = await response.json();
        if (!response.ok || json.status !== "success")
          throw Error(json.message || "Não foi possível consultar.");
        return json.data;
      } finally {
        controllers.delete(controller);
      }
    }
    function adjustment(student, area, gen) {
      const panel = node("section", "di-panel"),
        title = node("h2", null, "Ajustar pontos — " + student.nome),
        form = node("form", "di-form"),
        notice = node("p", "di-muted");
      notice.setAttribute("role", "status");
      const field = (label, control) => {
        const box = node("label", "di-field"),
          text = node("span", null, label);
        control.setAttribute("aria-label", label);
        box.append(text, control);
        form.append(box);
        return control;
      };
      const nodeResult = node("select");
      for (const [value, text] of [
        ["add", "Adicionar pontos"],
        ["subtract", "Retirar pontos"],
      ]) {
        const nodeResultAtual2 = node("option", null, text);
        nodeResultAtual2.value = value;
        nodeResult.append(nodeResultAtual2);
      }
      field("Operação", nodeResult);
      const qty = field("Quantidade", node("input"));
      qty.type = "text";
      qty.inputMode = "decimal";
      qty.required = true;
      qty.placeholder = "Ex.: 10 ou 0,5";
      qty.maxLength = 12;
      const reason = field("Motivo", node("input"));
      reason.type = "text";
      reason.required = true;
      reason.minLength = 3;
      reason.maxLength = 500;
      const controls = node("div", "di-actions"),
        save = node("button", "di-button", "Salvar ajuste"),
        cancel = button("Cancelar", () => {
          if (!busy) panel.remove();
        });
      save.type = "submit";
      controls.append(save, cancel);
      form.append(controls, notice);
      const log = node("div", "di-muted");
      panel.append(title, form, log);
      area.before(panel);
      let busy = false,
        key = null;
      const valid = () => alive && gen === generation && panel.isConnected;
      for (const input of [nodeResult, qty, reason])
        input.addEventListener("input", () => {
          key = null;
        });
      async function history() {
        try {
          const rows = await request(
            "/api/institution-point-adjustments.php?" +
              new URLSearchParams({
                institution_id: house,
                student_id: student.id,
              }),
          );
          if (!valid()) return;
          log.replaceChildren();
          if (rows.length) {
            log.append(node("h4", null, "Últimos ajustes"));
            const list = node("ul");
            for (const row of rows.slice(0, 10)) {
              const sign = Number(row.delta_milli) >= 0 ? "+" : "",
                who =
                  row.actor === "admin:global"
                    ? "Administração geral"
                    : "Instituição",
                date = new Date(
                  row.created_at.replace(" ", "T") + "Z",
                ).toLocaleString("pt-BR");
              list.append(
                node(
                  "li",
                  null,
                  sign +
                    number(Number(row.delta_milli) / 1000) +
                    " pontos · " +
                    date +
                    " · " +
                    who +
                    " · " +
                    row.reason,
                ),
              );
            }
            log.append(list);
          }
        } catch (error) {
          if (valid() && error.name !== "AbortError")
            log.textContent = error.message;
        }
      }
      form.onsubmit = async (event) => {
        event.preventDefault();
        if (busy) return;
        const quantity = qty.value.trim().replace(",", ".");
        if (
          !/^(0|[1-9][0-9]{0,6})(?:\.[0-9]{1,3})?$/.test(quantity) ||
          Number(quantity) <= 0 ||
          Number(quantity) > 1000000
        ) {
          notice.textContent =
            "Informe uma quantidade positiva, com até três casas decimais.";
          return;
        }
        const explanation = reason.value.trim();
        if (explanation.length < 3) {
          notice.textContent = "Informe o motivo do ajuste.";
          return;
        }
        key = key || crypto.randomUUID();
        busy = true;
        const disabledStates = new Map();
        for (const control of root.querySelectorAll(
          "button,input,select,textarea",
        )) {
          disabledStates.set(control, control.disabled);
          control.disabled = true;
        }
        notice.textContent = "Salvando ajuste…";
        try {
          await request(
            "/api/institution-point-adjustments.php?" +
              new URLSearchParams({
                institution_id: house,
              }),
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                student_id: Number(student.id),
                operation: nodeResult.value,
                quantity,
                reason: explanation,
                request_key: key,
              }),
            },
          );
          if (!valid()) return;
          key = null;
          window.dispatchEvent(new Event("dm-task-bonus-changed"));
          options.notify?.("Ajuste de pontos salvo.");
          list();
        } catch (error) {
          if (valid() && error.name !== "AbortError")
            notice.textContent = error.message;
        } finally {
          busy = false;
          if (valid())
            for (const [control, disabled] of disabledStates)
              control.disabled = disabled;
        }
      };
      history();
      qty.focus();
    }
    async function list() {
      const gen = ++generation;
      for (const controller of controllers) controller.abort();
      root.replaceChildren();
      const tools = node("form", "di-tools"),
        find = node("input", "di-search");
      find.type = "search";
      find.placeholder = "Pesquisar aluno";
      find.setAttribute("aria-label", "Pesquisar aluno");
      find.value = search;
      const submit = node("button", "di-button", "Pesquisar");
      submit.type = "submit";
      tools.append(find, submit);
      root.append(tools);
      tools.onsubmit = (event) => {
        event.preventDefault();
        search = find.value;
        page = 1;
        list();
      };
      const area = node("div", "di-panel di-table-wrap");
      area.append(node("p", "di-muted", "Carregando pontuação…"));
      root.append(area);
      try {
        const result = await request(
          "/api/institutions.php?" +
            new URLSearchParams({
              resource: "points",
              id: house,
              q: search,
              page,
              limit: 20,
            }),
        );
        if (!alive || gen !== generation) return;
        area.replaceChildren();
        page = result.page;
        const table = node("table", "di-table"),
          head = node("thead"),
          header = node("tr");
        for (const title of [
          "Aluno",
          "Ano",
          "Pontos do ranking",
          "Tokens disponíveis",
          "Ações",
        ]) {
          const nodeResult = node("th", null, title);
          nodeResult.scope = "col";
          header.append(nodeResult);
        }
        head.append(header);
        table.append(head);
        const body = node("tbody");
        for (const student of result.items) {
          const row = node("tr");
          row.dataset.id = student.id;
          row.append(
            node("td", null, student.nome),
            node("td", null, student.ano || "—"),
            node("td", null, number(student.ranking_points)),
            node("td", null, number(student.available_tokens)),
          );
          const action = node("td");
          action.append(
            button("Ajustar pontos", () => {
              root
                .querySelectorAll("section.di-panel")
                .forEach((item) => item.remove());
              adjustment(student, area, gen);
            }),
          );
          row.append(action);
          body.append(row);
        }
        table.append(body);
        area.append(table);
        if (!result.items.length)
          area.append(node("p", "di-muted", "Nenhum aluno encontrado."));
        const pages = node("div", "di-panel di-actions");
        if (page > 1)
          pages.append(
            button("Anterior", () => {
              page--;
              list();
            }),
          );
        pages.append(
          node(
            "span",
            "di-muted",
            "Página " + page + " de " + result.totalPages,
          ),
        );
        if (page < result.totalPages)
          pages.append(
            button("Próxima", () => {
              page++;
              list();
            }),
          );
        root.append(pages);
      } catch (error) {
        if (alive && gen === generation && error.name !== "AbortError") {
          area.replaceChildren(node("p", "di-notice", error.message));
          options.notify?.(error.message);
        }
      }
    }
    list();
    return () => {
      alive = false;
      ++generation;
      for (const controller of controllers) controller.abort();
      root.replaceChildren();
      root.classList.remove("di-root", "dp-management");
    };
  }
  window.DMInstitutionPoints = Object.freeze({
    mount,
  });
})();
